import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostLimitSubjectsFetchFailedAction = {
	type: 'AI_COST_LIMIT_SUBJECTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostLimitSubjectsFetchFailedAction => ({
	type: 'AI_COST_LIMIT_SUBJECTS_FETCH_FAILED',
	payload,
});
